import { TaskConstants } from '../../../constants';
export const checkESignStatus = data => {
  if (data.signed) {
    return getTaskStatus(TaskConstants.TASK_STATUS_COMPLETED);
  } else {
    return getTaskStatus(TaskConstants.TASK_STATUS_PENDING);
  }
};
export const getTaskStatus = status => {
  let showStatus = '';
  switch (status) {
    case 'Outstanding':
    case 'Pre gate Incomplete':
    case 'Requested':
    case 'Correction Needed':
    case 'Problem':
    case TaskConstants.TASK_STATUS_PENDING:
      showStatus = 'To Do';
      break;
    case 'Pre UW Incomplete':
    case 'Pre gate Accepted':
    case 'Borrower Submitted':
    case 'Pre UW Accepted':
    case 'Received - Pending Review':
    case 'Received':
      showStatus = 'In Review';
      break;
    case 'Completed':
    case 'Approved':
    case TaskConstants.TASK_STATUS_COMPLETED:
      showStatus = 'Completed';
  }
  return showStatus;
};
export const checkDocuments = (name, data) => {
  if (data !== undefined) return data[name];
};
//# sourceMappingURL=CommonUtils.js.map